import { ReactNode } from "react"
import { Provider } from "react-redux"
import { store } from "../app/store"
import { AuthProvider } from "./AuthProvider"
import { ConfigProvider } from "./ConfigProvider"
import { AxiosProvider } from "./AxiosProvider"

interface GlobalProviderProps {
  children: ReactNode
}

export const GlobalProvider = (props: GlobalProviderProps) => {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <AuthProvider>
          <AxiosProvider>{props.children}</AxiosProvider>
        </AuthProvider>
      </ConfigProvider>
    </Provider>
  )
}
